import e from "../managers/braze-instance.js";
import ir from "./feature-flags-provider-factory.js";
function tr(r, t, a = !1) {
  if (e.X()) return ir.rr().refreshFeatureFlags(r, t, a);
}
export function refreshFeatureFlags(r, e) {
  tr(r, e);
}
export default tr;
